<div 
    class="absolute h-screen w-full z-[2] top-0 left-0 transition-opacity duration-500 ease-in-out"
    [class]="showViewer() ? 'pointer-events-auto' : 'opacity-0 pointer-events-none'"
> 
    
    <dvm-viewer3d [service]="viewer3d"/>

</div>